import React from 'react';
import './BreadcrumbItem.css';
const BreadcrumbItem = (props) => {
    return (React.createElement("li", { key: props.key, className: `breadcrumb-item breadcrumb-item-default ${props.className ?? ''}`, style: props.style }, props.linkItem.isCurrent ? (React.createElement("span", { className: "breadcrumb-current ml-[5px]" }, props.linkItem.text)) : (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "breadcrumb-link ml-[5px]", onClick: () => props.onClick(props.linkItem) }, props.linkItem.text),
        !props.ignoreSeparator && (React.createElement("span", { className: "text-global-link-blue", "aria-hidden": "true" }, "/"))))));
};
export default BreadcrumbItem;
